import { URL, handleErrors } from "./depannageActions"
import { catchApiError } from "./apiHelpers"

// Slice e-mails (GE-25). Ce qui vivait dans `atelierInfo` déménage ici : les
// e-mails ne sont plus une affaire d'atelier, la file est générique
// atelier/dépannage.

export const EMAIL_DOMAINE_ATELIER = 0
export const EMAIL_DOMAINE_DEPANNAGE = 1
export const EMAIL_DOMAINE_LOCATION = 2

// Modèle utilisé par l'envoi automatique du devis (transition « en attente
// client ») : identifié par son CODE, stable, et non par son id de base.
export const EMAIL_TEMPLATE_CODE_DEVIS = "atelier_devis"

const authHeaders = (token) => ({
	Accept: "application/json, text/plain",
	"Content-type": "application/json",
	Authorization: `Bearer ${token}`,
})

// ─── Historique des envois d'une fiche ────────────────────────────────────
export const FETCH_EMAILS_BEGIN = "FETCH_EMAILS_BEGIN"
export const FETCH_EMAILS_SUCCESS = "FETCH_EMAILS_SUCCESS"
export const FETCH_EMAILS_ERROR = "FETCH_EMAILS_ERROR"

export const fetchEmailsBegin = () => ({ type: FETCH_EMAILS_BEGIN })
export const fetchEmailsSuccess = (payload) => ({
	type: FETCH_EMAILS_SUCCESS,
	payload,
})
export const fetchEmailsError = (payload) => ({
	type: FETCH_EMAILS_ERROR,
	payload,
})

export function fetchEmails(ficheId, domaine = EMAIL_DOMAINE_ATELIER) {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch(fetchEmailsBegin())
		return fetch(
			`${URL}api/emails?domaine=${domaine}&fiche_id=${ficheId}`,
			{ headers: { Authorization: `Bearer ${token}` } },
		)
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => dispatch(fetchEmailsSuccess(json)))
			.catch(catchApiError(dispatch, fetchEmailsError))
	}
}

// ─── Mise en file d'un envoi ──────────────────────────────────────────────
export const POST_EMAIL_BEGIN = "POST_EMAIL_BEGIN"
export const POST_EMAIL_SUCCESS = "POST_EMAIL_SUCCESS"
export const POST_EMAIL_ERROR = "POST_EMAIL_ERROR"
export const POST_EMAIL_RESET = "POST_EMAIL_RESET"

export const postEmailBegin = () => ({ type: POST_EMAIL_BEGIN })
export const postEmailReset = () => ({ type: POST_EMAIL_RESET })
export const postEmailSuccess = (payload) => ({
	type: POST_EMAIL_SUCCESS,
	payload,
})
export const postEmailError = (payload) => ({
	type: POST_EMAIL_ERROR,
	payload,
})

export function postEmail(data) {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch(postEmailBegin())
		return fetch(`${URL}api/emails`, {
			method: "post",
			headers: authHeaders(token),
			body: JSON.stringify(data),
		})
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => dispatch(postEmailSuccess(json)))
			// { silent: true } : l'erreur s'affiche DANS le modal d'envoi, qui
			// reste ouvert (règle hybride des erreurs — pas de toast en plus).
			.catch(catchApiError(dispatch, postEmailError, { silent: true }))
	}
}

// ─── Documents joignables ─────────────────────────────────────────────────
// Règle unique : proposé ⇔ le fichier existe (ni payeur, ni destinataire, ni
// date). Le backend est seul juge, le front n'en déduit rien.
export const FETCH_EMAIL_DOCUMENTS_SUCCESS = "FETCH_EMAIL_DOCUMENTS_SUCCESS"

export const fetchEmailDocumentsSuccess = (payload) => ({
	type: FETCH_EMAIL_DOCUMENTS_SUCCESS,
	payload,
})

export function fetchEmailDocuments(ficheId, domaine = EMAIL_DOMAINE_ATELIER) {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		return fetch(
			`${URL}api/emails/documents?domaine=${domaine}&fiche_id=${ficheId}`,
			{ headers: { Authorization: `Bearer ${token}` } },
		)
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				dispatch(fetchEmailDocumentsSuccess(json))
				// Rendu à l'appelant aussi : l'envoi automatique du devis doit
				// retrouver LE document tout juste généré.
				return json
			})
			.catch(catchApiError(dispatch, null))
	}
}

// ─── Modèles d'e-mail ─────────────────────────────────────────────────────
export const FETCH_EMAIL_TEMPLATES_SUCCESS = "FETCH_EMAIL_TEMPLATES_SUCCESS"

export const fetchEmailTemplatesSuccess = (payload) => ({
	type: FETCH_EMAIL_TEMPLATES_SUCCESS,
	payload,
})

export function fetchEmailTemplates(domaine) {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		const q = domaine === undefined ? "" : `?domaine=${domaine}`
		return fetch(`${URL}api/emails/templates${q}`, {
			headers: { Authorization: `Bearer ${token}` },
		})
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				dispatch(fetchEmailTemplatesSuccess(json))
				return json
			})
			.catch(catchApiError(dispatch, null))
	}
}

export function saveEmailTemplate(data) {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		return fetch(`${URL}api/emails/templates`, {
			method: "post",
			headers: authHeaders(token),
			body: JSON.stringify(data),
		})
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => json)
			// Le modal de configuration affiche l'erreur (variable inconnue,
			// code déjà pris) : pas de toast par-dessus.
			.catch(catchApiError(dispatch, null, { silent: true }))
	}
}

export function deleteEmailTemplate(id) {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		return fetch(`${URL}api/emails/templates`, {
			method: "delete",
			headers: authHeaders(token),
			body: JSON.stringify({ id }),
		})
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				dispatch(fetchEmailTemplatesSuccess(json))
				return json
			})
			.catch(catchApiError(dispatch, null))
	}
}

// ─── Aperçu ───────────────────────────────────────────────────────────────
// MÊME chemin de rendu que la mise en file côté serveur : ce qui s'affiche
// ici est exactement ce qui partira.
export function fetchEmailPreview(data) {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		return fetch(`${URL}api/emails/preview`, {
			method: "post",
			headers: authHeaders(token),
			body: JSON.stringify(data),
		})
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => json)
			.catch(catchApiError(dispatch, null, { silent: true }))
	}
}

export function sendEmailTest(data) {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		return fetch(`${URL}api/emails/test`, {
			method: "post",
			headers: authHeaders(token),
			body: JSON.stringify(data),
		})
			.then(handleErrors)
			.then((res) => res.json())
			.catch(catchApiError(dispatch, null))
	}
}

export function fetchDernierTest() {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		return fetch(`${URL}api/emails/test`, {
			headers: { Authorization: `Bearer ${token}` },
		})
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => json.dernier)
			.catch(() => null)
	}
}
